import React, { Fragment, useEffect } from 'react';
import { usePlace } from '../../hooks/usePlace';
import { GeoJSON, useMap, Popup } from 'react-leaflet';
import _, { isEmpty } from 'lodash';
import * as Leaflet from 'leaflet';
import { useMainMap } from '@bvt-features/mainmap/mainmap/hook/useMainMap';
import { useProject } from '@bvt-features/mapp/project/hooks/useProject';
import { useLocation } from 'react-router';

export function getBounds(value) {
  return Leaflet.geoJSON(value).getBounds();
}

const RenderGeojsonLayer = ({ geojsonData, styles }) => {
  if (isEmpty(geojsonData)) {
    return null;
  }
  return (
    <GeoJSON
      data={geojsonData}
      key={geojsonData.properties?.displayName || 'geojson-layer'}
      ref={(ref) => {
        if (ref && ref.setZIndex) {
          ref.setZIndex(1);
        }
      }}
      style={() => styles}
    >
      <Popup closeButton={false}>
        <center>{geojsonData.properties?.displayName || null}</center>
      </Popup>
    </GeoJSON>
  );
};

const RenderGejson = ({ geojson, style }) => {
  const { provinsi, kota, kecamatan, desa } = geojson;
  return (
    <React.Fragment>
      <RenderGeojsonLayer geojsonData={provinsi} styles={style} />
      <RenderGeojsonLayer geojsonData={kota} styles={style} />
      <RenderGeojsonLayer geojsonData={kecamatan} styles={style} />
      <RenderGeojsonLayer geojsonData={desa} styles={style} />
    </React.Fragment>
  );
};

export function GeoJsonMapAdvanceSearch() {
  const uLocation = useLocation();
  const PLACE = usePlace();
  const initialMap = useMap();
  const MAINMAP = useMainMap();
  const PROJECT = useProject();

  const styleFinder = _.find(
    MAINMAP.state.layerVisibilityList,
    (v) => v.key === 'ADM_BOUNDARY'
  );

  /**
   * @type {import('leaflet').PathOptions}
   */
  const style = {
    color: '#748DA6',
    stroke: 1,
    fillColor: '#748DA6',
    fillOpacity: styleFinder?.isActive ? styleFinder?.opacity : 0,
    opacity: styleFinder?.isActive ? styleFinder?.opacity : 0,
  };

  useEffect(() => {
    const data = PLACE?.state.advance.list;
    const stepLast = PROJECT.state.detail.id_last_step;
    const isRestricted =
      PLACE.state.country_mandala.country_id !== 1 && stepLast === 7;

    const geojsonPayload = {};

    const polygonMap = {
      polygon_provinsi: 'provinsi',
      polygon_kota: 'kota',
      polygon_kecamatan: 'kecamatan',
      polygon_desa: 'desa',
    };

    Object.entries(polygonMap).forEach(([polygonKey, geojsonKey]) => {
      const polygonData = data?.[polygonKey];
      if (!isEmpty(polygonData)) {
        if (!isRestricted) {
          initialMap.flyToBounds(getBounds(polygonData));
        }
        geojsonPayload[geojsonKey] = polygonData;
      } else {
        geojsonPayload[geojsonKey] = null;
      }
    });
    if (!isEmpty(geojsonPayload) && Object.values(geojsonPayload).some(v => v !== null)) {
      PLACE.setGeojson(geojsonPayload);
    }
  }, [PLACE.state.advance]);

  useEffect(() => {
    if (PLACE?.state?.geojson?.provinsi === null) {
      MAINMAP.removeLayer('ADM_BOUNDARY');
    } else {
      MAINMAP.registerLayer({
        isActive: true,
        key: 'ADM_BOUNDARY',
        opacity: 0.3,
        title: 'Adminstrative boundary',
      });
    }

    return () => {
      MAINMAP.removeLayer('ADM_BOUNDARY');
    };
  }, [PLACE.state.geojson.provinsi]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window?.location?.search);
    const step = +urlParams?.get('step');
    const pathname = uLocation.pathname;
    if (
      (pathname.includes('grid-analysis') && step === 6) ||
      (pathname.includes('site-profiling') && step === 7)
    ) {
      ['provinsi', 'kota', 'kecamatan', 'desa'].forEach((placeType) =>
        PLACE.setGeojson({ [placeType]: null })
      );
    }
  }, [uLocation.search, PLACE.state?.advance?.list]);

  return (
    <Fragment>
      {initialMap && styleFinder?.isActive ? (
        <RenderGejson geojson={PLACE.state.geojson} style={style} />
      ) : null}
    </Fragment>
  );
}
